<template>
  <div class="codeBox">
    <img
      src="../../assets/img/footer/footer_icon.png"
      alt=""
    >
  </div>
</template>

<script>
import { reqSchemeUrl } from '@/api/openMini';
import {miniSchemeUrl} from '@/utils/common'

export default {
  components: {
  },
  data() {
    return {
      communityId: this.$route.query.communityId,

    };
  },

  computed: {

  },
  mounted() {
    this.getSchemeUrl();
  },

  methods: {
    async getSchemeUrl() {
      const schemeLink= await  miniSchemeUrl('wxdb89cfa2bb60f779','/subPackages/codePage/codePage',`communityId=${this.communityId}`)
      window.location.href=schemeLink;
    },

  },

};

</script>

<style lang="scss" scoped>
.codeBox {
  position: relative;
  width: 100%;
  height: 100vh;
  img {
    position: absolute;
    top: 40%;
    left: 50%;
    width: 300px;
    transform: translate(-50%, -50%);
  }
}
</style>
